import { queryOptions } from '@tanstack/react-query';
import { getRecommendProducts } from '~/apis/rec';

/** 메루카리 상품상세 조회를 위한 쿼리 옵션 */

export const recommendProductsOptions = (params: Parameters<typeof getRecommendProducts>[0]) => {
  const options = queryOptions({
    queryKey: ['product', 'recommendProducts', params],
    queryFn: () => getRecommendProducts(params),
    select: (response) => response.data,
    enabled: Boolean(params.pid),
    retry: 0,
  });

  return options;
};
